/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractSnapshotFormComponent,
  formSchemaBuilderByEntityConfig,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import {
  CS_MASTER_HEADING_INFO_ENTITY_CONFIG,
  CSMasterHeadingInfo,
} from '../../../resources/cs-master.model';

@Component({
  standalone: false,
  selector: 'gh-cs-master-detail-heading-form',
  templateUrl: 'cs-master-detail-heading-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsMasterDetailHeadingFormComponent extends AbstractSnapshotFormComponent<CSMasterHeadingInfo> implements OnInit {

  @Input() sequence: number;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  protected buildForm(snapshot: FormStateSnapshot<CSMasterHeadingInfo>): FormState<CSMasterHeadingInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        ...formSchemaBuilderByEntityConfig(getFormStateSnapshotValue(snapshot),
                                           CS_MASTER_HEADING_INFO_ENTITY_CONFIG),
        isNewPage: void 0,
        sequence: void 0,
      },
    });
  }
}
